import api from 'core/util/api';
import { AppProtocolRaw } from '@kentik/ui-shared/types/lookup.types';
import { UseQueryOptions } from '@tanstack/react-query';

const queryFn = () => api.get('/api/ui/dictionary/appProtocols') as Promise<AppProtocolRaw[]>;

export const appProtocolsQuery = {
  queryKey: ['appProtocolsRaw'] as const,
  queryFn,
  staleTime: 300000
} as const satisfies UseQueryOptions<AppProtocolRaw[], Error, AppProtocolRaw[], readonly ['appProtocolsRaw']>;
